import type { ComponentProps } from 'react';

import { createLink } from '@tanstack/react-router';
import { Link as AriaLink, MenuItem } from 'react-aria-components';

import { getSecureRel } from '@/utils/get-secure-rel';

export const Link = createLink(AriaLink);
export type LinkProps = ComponentProps<typeof Link>;
export const MenuItemLink = createLink(MenuItem);

export type ExternalLinkProps = Omit<
  ComponentProps<typeof AriaLink>,
  'href'
> & {
  href: string;
};

/**
 * External/native anchor link.
 * Adds safe rel defaults when opening a new tab.
 */
export function ExternalLink({ target, rel, ...props }: ExternalLinkProps) {
  const secureRel = getSecureRel(target, rel);

  return <AriaLink {...props} target={target} rel={secureRel} />;
}
